import styled from 'styled-components';

import { brandFont } from 'components/layout/brand-font';
import { primitive } from 'styles/constants/primitives';

export const PriceAndCaloriesText = styled.p`
  margin: 0;
  padding: 0;
  font: ${brandFont.copyTwo};
`;

export const Price = styled.span`
  color: #198737;
`;

export const PriceCaloriesSeparator = styled.span`
  margin: 0 ${primitive.$spacing1};
`;
